export default __webpack_public_path__ + "static/erich-fischer-2003-76a28fc98f9ebd77946dac0d2dafb1d0.jpg";